import { Component, OnInit, ViewChild, Inject } from '@angular/core'
import { I18NService } from '@core'
import { STColumn, STComponent, STData } from '@delon/abc/st'
import { _HttpClient, ALAIN_I18N_TOKEN } from '@delon/theme'

import files from './files.json'

@Component({
  selector: 'app-support-guid',
  templateUrl: './guid.component.html',
})
export class SupportGuidComponent implements OnInit {
  @ViewChild('st') private readonly st!: STComponent
  datalist: STData[] = []
  columns: STColumn[] = [
    // { title: '编号', type: 'no', width: 80 },
    { title: this.i18n.fanyi('app.common.title'), index: 'name', render: 'nameTpl' },
    // {
    //   title: '操作',
    //   width: '80px',
    //   fixed: 'right',
    //   buttons: [
    //     {
    //       text: '查看',
    //       click: (_record) => {
    //         const { name } = _record
    //         window.open(`../../../../assets/guid/${name}.pdf`)
    //       },
    //     },
    //   ],
    // },
  ]

  showFile(name: any): void {
    //window.open(`/guid/${encodeURI(name)}.pdf`)
    window.open(`../../../../assets/guid/${encodeURI(name)}.pdf`)
  }

  constructor(
    private http: _HttpClient,
    @Inject(ALAIN_I18N_TOKEN) protected i18n: I18NService,
  ) {}
  ngOnInit(): void {
    this.datalist = files.map((item: any) => ({
      ...item,
      url: `../../../../assets/guid/${item.name}pdf`,
    }))
  }
}
